import styled from "styled-components/macro";

export const MenuWrapper = styled.div`
  background-color: var(--menu-color);
  padding: 4px;
  border-radius: 12px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
  min-height: 40px;
`;
